import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { RestApiModel } from '../../../shared/model/rest-api.model';
import { ProductUpsertArrayModel } from '../model/products/bulk-add-product-array.model';
import { ProductWarrantyUpsertArrayModel } from '../model/products/bulk-add-warranty-array.model';

/**
 * @name BulkAddProductsService
 */
@Injectable()
export class BulkAddProductsService {
  private endpointUpsert = RestApiModel.STARGATE_API_URL + '/productUpsert';
  private endpointWarrantyUpsert = RestApiModel.STARGATE_API_URL + '/productWarranty';

  // Resolve HTTP using the constructor
  constructor(private http: HttpClient) {}

  /**
   * Post BulkProductUpsert
   * @param {ProductUpsertModel} ProductUpsertModel
   * @returns {Observable<any>}
   */
  productUpsert(upsertArrayModel: ProductUpsertArrayModel): Observable<any> {
    return this.http.post(this.endpointUpsert, upsertArrayModel) as Observable<
      any
    >;
  }

  /**
   * Post BulkProductWarrantyUpsert
   * @param {ProductWarrantyUpsertModel} ProductWarrantyUpsertModel
   * @returns {Observable<any>}
   */
   productWarranty(productWarrantyUpsertArrayModel: ProductWarrantyUpsertArrayModel): Observable<any> {
    return this.http.put(this.endpointWarrantyUpsert, productWarrantyUpsertArrayModel) as Observable<
      any
    >;
  }
}
